import { PlatformContext, CustomManifestAction } from '../types';
import { getDataBindingOverrideActions } from '../dataBindingOverrides';
import { EditorPointer } from '@wix/editorx-core-api';
import { CompRef } from '@wix/document-services-types';

type OverrideActionsProvider = (
  platformContext: PlatformContext,
  editorPointer: EditorPointer<CompRef>,
) => Record<string, CustomManifestAction> | null;

const overrideActionsProviders: OverrideActionsProvider[] = [
  getDataBindingOverrideActions,
];

export const getCustomActionsOverrides = (
  platformContext: PlatformContext,
  editorPointer: EditorPointer<CompRef>,
): Record<string, CustomManifestAction> => {
  let customOverrideActions: Record<string, CustomManifestAction> = {};

  for (const overrideProvider of overrideActionsProviders) {
    const overrideActions = overrideProvider(platformContext, editorPointer);
    if (overrideActions) {
      customOverrideActions = {
        ...customOverrideActions,
        ...overrideActions,
      };
    }
  }

  return customOverrideActions;
};
